<template>
        <div class="sm:py-12" v-if="notification">
            <div class="mx-auto max-w-3xl sm:px-6 lg:px-8">
                <div class="overflow-hidden bg-white shadow-sm sm:rounded-lg">
                    <div class="p-6">
                        <div class="space-y-6">
                            <!-- Notification Header -->
                            <div class="flex justify-between items-start">
                                <div>
                                    <h3 class="text-2xl font-bold text-gray-900">
                                        {{ notification.data.title || 'Notification' }}
                                    </h3>
                                    <p class="mt-2 text-sm text-gray-500">
                                        {{ formatDate(notification.created_at) }}
                                    </p>
                                </div>
                                <span v-if="!notification.read_at"
                                      class="inline-flex items-center px-2.5 py-0.5 text-xs font-medium text-green-800 bg-green-100 rounded-full">
                                    New
                                </span>
                            </div>

                            <!-- Notification Content -->
                            <div class="max-w-none prose">
                                <p class="text-gray-700">
                                    {{ notification.data.message }}
                                </p>
                            </div>

                            <!-- Additional Details -->
                            <div v-if="notification.data.type === 'order_status_changed'"
                                 class="p-4 bg-gray-50 rounded-lg">
                                <h4 class="mb-2 text-sm font-medium text-gray-900">Order Details</h4>
                                <div class="grid grid-cols-2 gap-4">
                                    <div>
                                        <p class="text-sm text-gray-500">Order ID</p>
                                        <p class="text-sm font-medium text-gray-900">#{{ notification.data.order_id }}</p>
                                    </div>
                                    <div>
                                        <p class="text-sm text-gray-500">Business</p>
                                        <p class="text-sm font-medium text-gray-900">{{ notification.data.business_name }}</p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="notification.data.url || notification.data.action_url" class="mt-6">
                                <RouterLink :to="url"
                                   class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-white uppercase bg-green-600 rounded-md border border-transparent transition duration-150 ease-in-out hover:bg-green-700 focus:bg-green-700 active:bg-green-900 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">
                                    {{ notification.data.button_text || 'View Details' }}
                                </RouterLink>
                            </div>

                            <!-- Action Button -->
                            <!-- <div v-if="notification.data.action_url" class="mt-6">
                                <a :href="notification.data.action_url"
                                   class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-white uppercase bg-green-600 rounded-md border border-transparent transition duration-150 ease-in-out hover:bg-green-700 focus:bg-green-700 active:bg-green-900 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">
                                    {{ notification.data.action_text || 'View Details' }} {{ url }}
                                </a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <p>Loading...</p>
        </div>
</template>

<script setup>
import { format } from 'date-fns';
import { useNotificationStore } from '@/stores/notificationStore';
import {onMounted, watchEffect} from 'vue';
import { storeToRefs } from 'pinia';
const notificationStore = useNotificationStore();
const route = useRoute();
const { notification } = storeToRefs(notificationStore);
onMounted(() => {
    notificationStore.fetchNotification(route.params.id);
});
const formatDate = (date) => {
    return format(new Date(date), 'MMM d, yyyy h:mm a');
};

const url = computed(() => {
  let url = notification.value.data.url || notification.value.data.action_url;
  if(url.includes('https://www.boxbuddy.me') || url.includes(import.meta.env.VITE_FRONTEND_URL) || url.includes('https://boxbuddy.me')){
    url = url.replace('https://www.boxbuddy.me', '');
    url = url.replace(import.meta.env.VITE_FRONTEND_URL, '');
    url = url.replace('https://boxbuddy.me', '');
  }
   return url.startsWith('/') ? url : `/${url}`;
});

watchEffect(() => {
    notificationStore.fetchNotification(route.params.id);
});
</script>

<style lang="scss" scoped>

</style>
